import React, { Suspense } from 'react'

import { useTranslation } from 'react-i18next'
import { Await, useLoaderData, useNavigation } from 'react-router-dom'

import LoadingMessage from '@components/LoadingMessage'
import DeletedScoresView from '@components/myScores/DeletedScoresView'
import LoadingSpinner from '@components/shared/LoadingSpinner'
import { DeletedScoresLoaderResponse } from '@pages/home/loaders/deletedScores.loader'
import { usePageTitle } from '@providers/LayoutProvider'

const DeletedScoresPage: React.FC = () => {
  const { t } = useTranslation()
  const data = useLoaderData() as DeletedScoresLoaderResponse
  const navigation = useNavigation()

  usePageTitle(t('titles.deletedScores'))

  const isReloading =
    navigation.state === 'loading' &&
    navigation.formData != null &&
    navigation.location.pathname === '/home/deletedScores'

  return (
    <>
      {isReloading && <LoadingMessage />}
      <Suspense
        fallback={
          <>
            {/* Spacer */}
            <div className="h-16 w-full" />

            <LoadingSpinner />
          </>
        }>
        <Await resolve={data.deletedScores}>
          {(deletedScoresResp) => (
            <DeletedScoresView initialData={deletedScoresResp} order={data.order} />
          )}
        </Await>
      </Suspense>
    </>
  )
}

export default DeletedScoresPage
